import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C1_CH1_L1_Name: {
    id: "course01.chapter01.lesson01.name",
  },
  C1_CH1_L1_P1_title: {
    id: "course01.chapter01.lesson01.page01.title",
  },
  C1_CH1_L1_P1_description: {
    id: "course01.chapter01.lesson01.page01.description",
  },
  C1_CH1_L1_T1_question: {
    id: "course01.chapter01.lesson01.task01.question",
  },
  C1_CH1_L1_T1_A1_Space: {
    id: "course01.chapter01.lesson01.task01.answer01",
  },
  C1_CH1_L1_T1_A1_Loudness: {
    id: "course01.chapter01.lesson01.task01.answer02",
  },
  C1_CH1_L1_T1_A1_Position: {
    id: "course01.chapter01.lesson01.task01.answer03",
  },
  C1_CH1_L1_T1_A1_Reverberation: {
    id: "course01.chapter01.lesson01.task01.answer04",
  },
  C1_CH1_L1_T1_A1_Electroacustics: {
    id: "course01.chapter01.lesson01.task01.answer05",
  },
  C1_CH1_L2_Name: {
    id: "course01.chapter01.lesson02.name",
  },
  C1_CH1_L2_P1_title: {
    id: "course01.chapter01.lesson02.page01.title",
  },
  C1_CH1_L2_P1_description: {
    id: "course01.chapter01.lesson02.page01.description",
  },
  C1_CH1_L2_P1_Tab_Title: {
    id: "course01.chapter01.lesson02.page01.tab_title",
  },
  C1_CH1_L2_P1_video_title: {
    id: "course01.chapter01.lesson02.page01.video.title",
  },
  C1_CH1_L2_P1_video_description: {
    id: "course01.chapter01.lesson02.page01.video.description",
  },
  C1_CH1_L2_P2_Tab_Title: {
    id: "course01.chapter01.lesson02.page02.tab_title",
  },
  C1_CH1_L2_P2_video_title: {
    id: "course01.chapter01.lesson02.page02.video.title",
  },
  C1_CH1_L2_P3_Tab_Title: {
    id: "course01.chapter01.lesson02.page03.tab_title",
  },
  C1_CH1_L2_P3_video_title: {
    id: "course01.chapter01.lesson02.page03.video.title",
  },

  C1_CH1_L2_T1_question: {
    id: "course01.chapter01.lesson02.task01.question",
  },
  C1_CH1_L2_T1_A1: {
    id: "course01.chapter01.lesson02.task01.answer01",
  },
  C1_CH1_L2_T1_A2: {
    id: "course01.chapter01.lesson02.task01.answer02",
  },
  C1_CH1_L2_T1_A3: {
    id: "course01.chapter01.lesson02.task01.answer03",
  },
  C1_CH1_L2_T1_A4: {
    id: "course01.chapter01.lesson02.task01.answer04",
  },
  C1_CH1_L2_T1_A5: {
    id: "course01.chapter01.lesson02.task01.answer05",
  },
  C1_CH1_L2_T1_G1: {
    id: "course01.chapter01.lesson02.task01.group01",
  },
  C1_CH1_L2_T1_G2: {
    id: "course01.chapter01.lesson02.task01.group02",
  },
  C1_CH1_L2_T1_G3: {
    id: "course01.chapter01.lesson02.task01.group03",
  },
  C1_CH1_L2_T1_G4: {
    id: "course01.chapter01.lesson02.task01.group04",
  },
  C1_CH1_L2_T1_G5: {
    id: "course01.chapter01.lesson02.task01.group05",
  },
  C1_CH1_L3_Name: {
    id: "course01.chapter01.lesson03.name",
  },

  C1_CH1_L3_P1_Title: {
    id: "course01.chapter01.lesson03.page01.title",
  },

  C1_CH1_L3_P1_Timeline1_Header: { id: "course01.chapter01.lesson03.page01.timeline1.header" },
  C1_CH1_L3_P1_Timeline1_Description: { id: "course01.chapter01.lesson03.page01.timeline1.description" },
  C1_CH1_L3_P1_Timeline2_Header: { id: "course01.chapter01.lesson03.page01.timeline2.header" },
  C1_CH1_L3_P1_Timeline2_Description: { id: "course01.chapter01.lesson03.page01.timeline2.description" },
  C1_CH1_L3_P1_Timeline3_Header: { id: "course01.chapter01.lesson03.page01.timeline3.header" },
  C1_CH1_L3_P1_Timeline3_Description: { id: "course01.chapter01.lesson03.page01.timeline3.description" },
  C1_CH1_L3_P1_Timeline4_Header: { id: "course01.chapter01.lesson03.page01.timeline4.header" },
  C1_CH1_L3_P1_Timeline4_Description: { id: "course01.chapter01.lesson03.page01.timeline4.description" },
  C1_CH1_L3_P1_Timeline5_Header: { id: "course01.chapter01.lesson03.page01.timeline5.header" },
  C1_CH1_L3_P1_Timeline5_Description: { id: "course01.chapter01.lesson03.page01.timeline5.description" },
  C1_CH1_L3_P1_Timeline6_Header: { id: "course01.chapter01.lesson03.page01.timeline6.header" },
  C1_CH1_L3_P1_Timeline6_Description: { id: "course01.chapter01.lesson03.page01.timeline6.description" },
  C1_CH1_L3_P1_Timeline7_Header: { id: "course01.chapter01.lesson03.page01.timeline7.header" },
  C1_CH1_L3_P1_Timeline7_Description: { id: "course01.chapter01.lesson03.page01.timeline7.description" },
  C1_CH1_L3_P1_Timeline8_Header: { id: "course01.chapter01.lesson03.page01.timeline8.header" },
  C1_CH1_L3_P1_Timeline8_Description: { id: "course01.chapter01.lesson03.page01.timeline8.description" },
  C1_CH1_L3_P1_Timeline9_Header: { id: "course01.chapter01.lesson03.page01.timeline9.header" },
  C1_CH1_L3_P1_Timeline9_Description: { id: "course01.chapter01.lesson03.page01.timeline9.description" },
  C1_CH1_L3_P1_Timeline10_Header: { id: "course01.chapter01.lesson03.page01.timeline10.header" },
  C1_CH1_L3_P1_Timeline10_Description: { id: "course01.chapter01.lesson03.page01.timeline10.description" },
  C1_CH1_L3_P1_Timeline11_Header: { id: "course01.chapter01.lesson03.page01.timeline11.header" },
  C1_CH1_L3_P1_Timeline11_Description: { id: "course01.chapter01.lesson03.page01.timeline11.description" },
  C1_CH1_L3_P1_Timeline12_Header: { id: "course01.chapter01.lesson03.page01.timeline12.header" },
  C1_CH1_L3_P1_Timeline12_Description: { id: "course01.chapter01.lesson03.page01.timeline12.description" },
  C1_CH1_L3_P1_Timeline13_Header: { id: "course01.chapter01.lesson03.page01.timeline13.header" },
  C1_CH1_L3_P1_Timeline13_Description: { id: "course01.chapter01.lesson03.page01.timeline13.description" },
  C1_CH1_L3_P1_Timeline14_Header: { id: "course01.chapter01.lesson03.page01.timeline14.header" },
  C1_CH1_L3_P1_Timeline14_Description: { id: "course01.chapter01.lesson03.page01.timeline14.description" },
  C1_CH1_L3_P1_Timeline15_Header: { id: "course01.chapter01.lesson03.page01.timeline15.header" },
  C1_CH1_L3_P1_Timeline15_Description: { id: "course01.chapter01.lesson03.page01.timeline15.description" },
  C1_CH1_L3_P1_Timeline16_Header: { id: "course01.chapter01.lesson03.page01.timeline16.header" },
  C1_CH1_L3_P1_Timeline16_Description: { id: "course01.chapter01.lesson03.page01.timeline16.description" },
  C1_CH1_L3_P1_Timeline17_Header: { id: "course01.chapter01.lesson03.page01.timeline17.header" },
  C1_CH1_L3_P1_Timeline17_Description: { id: "course01.chapter01.lesson03.page01.timeline17.description" },
  C1_CH1_L3_P1_Timeline18_Header: { id: "course01.chapter01.lesson03.page01.timeline18.header" },
  C1_CH1_L3_P1_Timeline18_Description: { id: "course01.chapter01.lesson03.page01.timeline18.description" },
  C1_CH1_L3_P1_Timeline19_Header: { id: "course01.chapter01.lesson03.page01.timeline19.header" },
  C1_CH1_L3_P1_Timeline19_Description: { id: "course01.chapter01.lesson03.page01.timeline19.description" },
  C1_CH1_L3_P1_Timeline20_Header: { id: "course01.chapter01.lesson03.page01.timeline20.header" },
  C1_CH1_L3_P1_Timeline20_Description: { id: "course01.chapter01.lesson03.page01.timeline20.description" },
  C1_CH1_L3_P1_Timeline21_Header: { id: "course01.chapter01.lesson03.page01.timeline21.header" },
  C1_CH1_L3_P1_Timeline21_Description: { id: "course01.chapter01.lesson03.page01.timeline21.description" },

  C1_CH1_L3_T1_Question: {
    id: "course01.chapter01.lesson03.task01.question",
  },
  C1_CH1_L3_T1_A1_Concept: {
    id: "course01.chapter01.lesson03.task01.answer01",
  },
  C1_CH1_L3_T1_A2_Format: {
    id: "course01.chapter01.lesson03.task01.answer02",
  },
  C1_CH1_L3_T1_A3_Both: {
    id: "course01.chapter01.lesson03.task01.answer03",
  },
  C1_CH1_L3_T1_A4_Neither: {
    id: "course01.chapter01.lesson03.task01.answer04",
  },
  C1_CH1_L3_T2_Question: {
    id: "course01.chapter01.lesson03.task02.question",
  },
  C1_CH1_L3_T3_Question: {
    id: "course01.chapter01.lesson03.task03.question",
  },
  C1_CH1_L3_T3_A1_New: {
    id: "course01.chapter01.lesson03.task03.answer01",
  },
  C1_CH1_L3_T3_A2_Old: {
    id: "course01.chapter01.lesson03.task03.answer02",
  },
  C1_CH1_L3_T4_Question: {
    id: "course01.chapter01.lesson03.task04.question",
  },
  C1_CH1_L3_T4_A1_30: {
    id: "course01.chapter01.lesson03.task04.answer01",
  },
  C1_CH1_L3_T4_A1_40: {
    id: "course01.chapter01.lesson03.task04.answer02",
  },
  C1_CH1_L3_T4_A1_60: {
    id: "course01.chapter01.lesson03.task04.answer03",
  },
  C1_CH1_L3_T4_A1_90: {
    id: "course01.chapter01.lesson03.task04.answer04",
  },
  C1_CH1_L3_T5_Question: {
    id: "course01.chapter01.lesson03.task05.question",
  },
  C1_CH1_L3_T5_A1_Einstein: {
    id: "course01.chapter01.lesson03.task05.answer01",
  },
  C1_CH1_L3_T5_A2_Tesla: {
    id: "course01.chapter01.lesson03.task05.answer02",
  },
  C1_CH1_L3_T5_A3_Blumlein: {
    id: "course01.chapter01.lesson03.task05.answer03",
  },
  C1_CH1_L3_T6_Question: {
    id: "course01.chapter01.lesson03.task06.question",
  },
  C1_CH1_L3_T6_A1_70: {
    id: "course01.chapter01.lesson03.task06.answer01",
  },
  C1_CH1_L3_T6_A2_40: {
    id: "course01.chapter01.lesson03.task06.answer02",
  },
  C1_CH1_L3_T6_A3_06: {
    id: "course01.chapter01.lesson03.task06.answer03",
  },
  C1_CH1_L3_T7_Question: {
    id: "course01.chapter01.lesson03.task07.question",
  },
  C1_CH1_L3_T7_A1_SO: {
    id: "course01.chapter01.lesson03.task07.answer01",
  },
  C1_CH1_L3_T7_A2_Gravity: {
    id: "course01.chapter01.lesson03.task07.answer02",
  },
  C1_CH1_L3_T7_A3_Fantasia: {
    id: "course01.chapter01.lesson03.task07.answer03",
  },
  C1_CH1_L3_T8_Question: {
    id: "course01.chapter01.lesson03.task08.question",
  },
  C1_CH1_L3_T8_A1_Channels: {
    id: "course01.chapter01.lesson03.task08.answer01",
  },
  C1_CH1_L3_T8_A2_Height: {
    id: "course01.chapter01.lesson03.task08.answer02",
  },
  C1_CH1_L3_T8_A3_Space: {
    id: "course01.chapter01.lesson03.task08.answer03",
  },
  C1_CH1_L3_T8_A4_All: {
    id: "course01.chapter01.lesson03.task08.answer04",
  },

  C1_CH1_L4_Name: {
    id: "course01.chapter01.lesson04.name",
  },
  C1_CH1_L4_P1_Title: {
    id: "course01.chapter01.lesson04.page01.title",
  },
  C1_CH1_L4_P1_Description: {
    id: "course01.chapter01.lesson04.page01.description",
  },
  C1_CH1_L4_P1_Table_H1: {
    id: "course01.chapter01.lesson04.page1.h1",
  },
  C1_CH1_L4_P1_Table_H2: {
    id: "course01.chapter01.lesson04.page1.h2",
  },
  C1_CH1_L4_P1_Table_H3: {
    id: "course01.chapter01.lesson04.page1.h3",
  },
  C1_CH1_L4_P1_Table_H4: {
    id: "course01.chapter01.lesson04.page1.h4",
  },
  C1_CH1_L4_P1_Table_H5: {
    id: "course01.chapter01.lesson04.page1.h5",
  },
  C1_CH1_L4_P1_Table_H6: {
    id: "course01.chapter01.lesson04.page1.h6",
  },
  C1_CH1_L4_P1_Table_H7: {
    id: "course01.chapter01.lesson04.page1.h7",
  },
  C1_CH1_L4_P1_Table_H8: {
    id: "course01.chapter01.lesson04.page1.h8",
  },
  C1_CH1_L4_P1_Table_H9: {
    id: "course01.chapter01.lesson04.page1.h9",
  },
  C1_CH1_L4_P1_Table_H10: {
    id: "course01.chapter01.lesson04.page1.h10",
  },
  C1_CH1_L4_P1_Table_H11: {
    id: "course01.chapter01.lesson04.page1.h11",
  },
  C1_CH1_L4_P1_Table_H12: {
    id: "course01.chapter01.lesson04.page1.h12",
  },
  C1_CH1_L4_P1_Table_H13: {
    id: "course01.chapter01.lesson04.page1.h13",
  },
  C1_CH1_L4_P1_Table_R1C1: {
    id: "course01.chapter01.lesson04.page1.r1c1",
  },
  C1_CH1_L4_P1_Table_R1C2: {
    id: "course01.chapter01.lesson04.page1.r1c2",
  },
  C1_CH1_L4_P1_Table_R1C3: {
    id: "course01.chapter01.lesson04.page1.r1c3",
  },
  C1_CH1_L4_P1_Table_R1C4: {
    id: "course01.chapter01.lesson04.page1.r1c4",
  },
  C1_CH1_L4_P1_Table_R1C5: {
    id: "course01.chapter01.lesson04.page1.r1c5",
  },
  C1_CH1_L4_P1_Table_R1C6: {
    id: "course01.chapter01.lesson04.page1.r1c6",
  },
  C1_CH1_L4_P1_Table_R1C7: {
    id: "course01.chapter01.lesson04.page1.r1c7",
  },
  C1_CH1_L4_P1_Table_R1C8: {
    id: "course01.chapter01.lesson04.page1.r1c8",
  },
  C1_CH1_L4_P1_Table_R1C9: {
    id: "course01.chapter01.lesson04.page1.r1c9",
  },
  C1_CH1_L4_P1_Table_R1C10: {
    id: "course01.chapter01.lesson04.page1.r1c10",
  },
  C1_CH1_L4_P1_Table_R1C11: {
    id: "course01.chapter01.lesson04.page1.r1c11",
  },
  C1_CH1_L4_P1_Table_R1C12: {
    id: "course01.chapter01.lesson04.page1.r1c12",
  },
  C1_CH1_L4_P1_Table_R1C13: {
    id: "course01.chapter01.lesson04.page1.r1c13",
  },
  C1_CH1_L4_P1_Table_R2C1: {
    id: "course01.chapter01.lesson04.page1.r2c1",
  },
  C1_CH1_L4_P1_Table_R2C2: {
    id: "course01.chapter01.lesson04.page1.r2c2",
  },
  C1_CH1_L4_P1_Table_R2C3: {
    id: "course01.chapter01.lesson04.page1.r2c3",
  },
  C1_CH1_L4_P1_Table_R2C4: {
    id: "course01.chapter01.lesson04.page1.r2c4",
  },
  C1_CH1_L4_P1_Table_R2C5: {
    id: "course01.chapter01.lesson04.page1.r2c5",
  },
  C1_CH1_L4_P1_Table_R2C6: {
    id: "course01.chapter01.lesson04.page1.r2c6",
  },
  C1_CH1_L4_P1_Table_R2C7: {
    id: "course01.chapter01.lesson04.page1.r2c7",
  },
  C1_CH1_L4_P1_Table_R2C8: {
    id: "course01.chapter01.lesson04.page1.r2c8",
  },
  C1_CH1_L4_P1_Table_R2C9: {
    id: "course01.chapter01.lesson04.page1.r2c9",
  },
  C1_CH1_L4_P1_Table_R2C10: {
    id: "course01.chapter01.lesson04.page1.r2c10",
  },
  C1_CH1_L4_P1_Table_R2C11: {
    id: "course01.chapter01.lesson04.page1.r2c11",
  },
  C1_CH1_L4_P1_Table_R2C12: {
    id: "course01.chapter01.lesson04.page1.r2c12",
  },
  C1_CH1_L4_P1_Table_R2C13: {
    id: "course01.chapter01.lesson04.page1.r2c13",
  },
  C1_CH1_L4_P1_Table_R3C1: {
    id: "course01.chapter01.lesson04.page1.r3c1",
  },
  C1_CH1_L4_P1_Table_R3C2: {
    id: "course01.chapter01.lesson04.page1.r3c2",
  },
  C1_CH1_L4_P1_Table_R3C3: {
    id: "course01.chapter01.lesson04.page1.r3c3",
  },
  C1_CH1_L4_P1_Table_R3C4: {
    id: "course01.chapter01.lesson04.page1.r3c4",
  },
  C1_CH1_L4_P1_Table_R3C5: {
    id: "course01.chapter01.lesson04.page1.r3c5",
  },
  C1_CH1_L4_P1_Table_R3C6: {
    id: "course01.chapter01.lesson04.page1.r3c6",
  },
  C1_CH1_L4_P1_Table_R3C7: {
    id: "course01.chapter01.lesson04.page1.r3c7",
  },
  C1_CH1_L4_P1_Table_R3C8: {
    id: "course01.chapter01.lesson04.page1.r3c8",
  },
  C1_CH1_L4_P1_Table_R3C9: {
    id: "course01.chapter01.lesson04.page1.r3c9",
  },
  C1_CH1_L4_P1_Table_R3C10: {
    id: "course01.chapter01.lesson04.page1.r3c10",
  },
  C1_CH1_L4_P1_Table_R3C11: {
    id: "course01.chapter01.lesson04.page1.r3c11",
  },
  C1_CH1_L4_P1_Table_R3C12: {
    id: "course01.chapter01.lesson04.page1.r3c12",
  },
  C1_CH1_L4_P1_Table_R3C13: {
    id: "course01.chapter01.lesson04.page1.r3c13",
  },
  C1_CH1_L4_T1_Question: {
    id: "course01.chapter01.lesson04.task1.question",
  },
  C1_CH1_L4_T1_Title: {
    id: "course01.chapter01.lesson04.task1.title",
  },
  C1_CH1_L4_T1_A1: {
    id: "course01.chapter01.lesson04.task1.answer01",
  },
  C1_CH1_L4_T1_A2: {
    id: "course01.chapter01.lesson04.task1.answer02",
  },
  C1_CH1_L4_T1_A3: {
    id: "course01.chapter01.lesson04.task1.answer03",
  },
  C1_CH1_L4_T1_A4: {
    id: "course01.chapter01.lesson04.task1.answer04",
  },
  C1_CH1_L4_T1_A5: {
    id: "course01.chapter01.lesson04.task1.answer05",
  },
  C1_CH1_L4_T1_A6: {
    id: "course01.chapter01.lesson04.task1.answer06",
  },
  C1_CH1_L4_T1_G1: {
    id: "course01.chapter01.lesson04.task1.g1",
  },
  C1_CH1_L4_T1_G2: {
    id: "course01.chapter01.lesson04.task1.g2",
  },

  C1_CH1_L5_Name: {
    id: "course01.chapter01.lesson05.name",
  },
  C1_CH1_L5_P1_Title: {
    id: "course01.chapter01.lesson05.page01.title",
  },
  C1_CH1_L5_P1_Description: {
    id: "course01.chapter01.lesson05.page01.description",
  },
  C1_CH1_L5_P2_Title: {
    id: "course01.chapter01.lesson05.page02.title",
  },
  C1_CH1_L5_P2_Description: {
    id: "course01.chapter01.lesson05.page02.description",
  },
  C1_CH1_L5_P2_Azimuth: {
    id: "course01.chapter01.lesson05.page02.azimuth",
  },
  C1_CH1_L5_P2_Eleveation: {
    id: "course01.chapter01.lesson05.page02.elevation",
  },
  C1_CH1_L5_P2_Radius: {
    id: "course01.chapter01.lesson05.page02.radius",
  },
  C1_CH1_L5_P3_Title: {
    id: "course01.chapter01.lesson05.page03.title",
  },
  C1_CH1_L5_P3_Description: {
    id: "course01.chapter01.lesson05.page03.description",
  },

  C1_CH1_L5_P4_Title: {
    id: "course01.chapter01.lesson05.page04.title",
  },
  C1_CH1_L5_P4_Description: {
    id: "course01.chapter01.lesson05.page04.description",
  },
  C1_CH1_L5_P4_Sound1: {
    id: "course01.chapter01.lesson05.page04.sound1",
  },
  C1_CH1_L5_P4_Sound2: {
    id: "course01.chapter01.lesson05.page04.sound2",
  },
  C1_CH1_L5_P4_Sound3: {
    id: "course01.chapter01.lesson05.page04.sound3",
  },
  C1_CH1_L5_P4_Sound4: {
    id: "course01.chapter01.lesson05.page04.sound4",
  },
  C1_CH1_L5_P4_Sound5: {
    id: "course01.chapter01.lesson05.page04.sound5",
  },
  C1_CH1_L5_P5_Title: {
    id: "course01.chapter01.lesson05.page05.title",
  },
  C1_CH1_L5_P5_Description: {
    id: "course01.chapter01.lesson05.page05.description",
  },

  C1_CH1_L5_P5_Sound1: {
    id: "course01.chapter01.lesson05.page05.sound1",
  },
  C1_CH1_L5_P5_Sound2: {
    id: "course01.chapter01.lesson05.page05.sound2",
  },

  C1_CH1_L5_P6_Title: {
    id: "course01.chapter01.lesson05.page06.title",
  },
  C1_CH1_L5_P6_Description: {
    id: "course01.chapter01.lesson05.page06.description",
  },
  C1_CH1_L5_P6_Sound1: {
    id: "course01.chapter01.lesson05.page06.sound1",
  },
  C1_CH1_L5_P6_Sound2: {
    id: "course01.chapter01.lesson05.page06.sound2",
  },

  C1_CH1_L5_T1_Question: {
    id: "course01.chapter01.lesson05.task01.question",
  },

  C1_CH1_L5_T1_G1: {
    id: "course01.chapter01.lesson05.task01.group1",
  },
  C1_CH1_L5_T1_G2: {
    id: "course01.chapter01.lesson05.task01.group2",
  },

  C1_CH1_L5_T1_A1: {
    id: "course01.chapter01.lesson05.task01.answer1",
  },
  C1_CH1_L5_T1_A2: {
    id: "course01.chapter01.lesson05.task01.answer2",
  },
  C1_CH1_L5_T1_A3: {
    id: "course01.chapter01.lesson05.task01.answer3",
  },
  C1_CH1_L5_T1_A4: {
    id: "course01.chapter01.lesson05.task01.answer4",
  },
  C1_CH1_L5_T1_A5: {
    id: "course01.chapter01.lesson05.task01.answer5",
  },

  C1_CH1_L5_T2_Question: {
    id: "course01.chapter01.lesson05.task02.question",
  },

  C1_CH1_L5_T2_G1: {
    id: "course01.chapter01.lesson05.task02.group1",
  },
  C1_CH1_L5_T2_G2: {
    id: "course01.chapter01.lesson05.task02.group2",
  },
  C1_CH1_L5_T2_G3: {
    id: "course01.chapter01.lesson05.task02.group3",
  },
  C1_CH1_L5_T2_G4: {
    id: "course01.chapter01.lesson05.task02.group4",
  },

  C1_CH1_L5_T2_A1: {
    id: "course01.chapter01.lesson05.task02.answer1",
  },
  C1_CH1_L5_T2_A2: {
    id: "course01.chapter01.lesson05.task02.answer2",
  },
  C1_CH1_L5_T2_A3: {
    id: "course01.chapter01.lesson05.task02.answer3",
  },
  C1_CH1_L5_T2_A4: {
    id: "course01.chapter01.lesson05.task02.answer4",
  },

  C1_CH1_L6_Name: {
    id: "course01.chapter01.lesson06.name",
  },
  C1_CH1_L6_P1_Title: {
    id: "course01.chapter01.lesson06.page01.title",
  },
  C1_CH1_L6_P1_ImageDescription: {
    id: "course01.chapter01.lesson06.page01.image-description",
  },
  C1_CH1_L6_P1_Description: {
    id: "course01.chapter01.lesson06.page01.description",
  },
  C1_CH1_L6_P2_Title: {
    id: "course01.chapter01.lesson06.page02.title",
  },
  C1_CH1_L6_P2_Description: {
    id: "course01.chapter01.lesson06.page02.description",
  },
  C1_CH1_L6_P3_Title: {
    id: "course01.chapter01.lesson06.page03.title",
  },
  C1_CH1_L6_P3_Description: {
    id: "course01.chapter01.lesson06.page03.description",
  },
  C1_CH1_L6_T1_Question: {
    id: "course01.chapter01.lesson06.task01.question",
  },
  C1_CH1_L6_T1_A1_Rot: {
    id: "course01.chapter01.lesson06.task01.answer01",
  },
  C1_CH1_L6_T1_A2_Nat: {
    id: "course01.chapter01.lesson06.task01.answer02",
  },
  C1_CH1_L6_T1_A3_Trans: {
    id: "course01.chapter01.lesson06.task01.answer03",
  },
  C1_CH1_L6_T2_Question: {
    id: "course01.chapter01.lesson06.task02.question",
  },
  C1_CH1_L6_T2_A1_Azi: {
    id: "course01.chapter01.lesson06.task02.answer01",
  },
  C1_CH1_L6_T2_A2_Pitch: {
    id: "course01.chapter01.lesson06.task02.answer02",
  },
  C1_CH1_L6_T2_A3_Surge: {
    id: "course01.chapter01.lesson06.task02.answer03",
  },

  C1_CH2_L1_Name: { id: "course01.chapter02.lesson01.name" },
  C1_CH2_L1_P1_Title: { id: "course01.chapter02.lesson01.page01.title" },
  C1_CH2_L1_P1_Description: { id: "course01.chapter02.lesson01.page01.description" },
  C1_CH2_L1_P2_Title: { id: "course01.chapter02.lesson01.page02.title" },
  C1_CH2_L1_P2_Description: { id: "course01.chapter02.lesson01.page02.description" },
  C1_CH2_L1_P3_Title: { id: "course01.chapter02.lesson01.page03.title" },
  C1_CH2_L1_P3_Description: { id: "course01.chapter02.lesson01.page03.description" },
  C1_CH2_L1_P3_SoundLabel: { id: "course01.chapter02.lesson01.page03.soundlabel" },

  C1_CH2_L1_P4_Title: { id: "course01.chapter02.lesson01.page04.title" },
  C1_CH2_L1_P4_Description: { id: "course01.chapter02.lesson01.page04.description" },
  C1_CH2_L1_P4_Col1Header: { id: "course01.chapter02.lesson01.page04.col1Header" },
  C1_CH2_L1_P4_Col1: { id: "course01.chapter02.lesson01.page04.col1" },
  C1_CH2_L1_P4_Col2: { id: "course01.chapter02.lesson01.page04.col2" },
  C1_CH2_L1_P4_Col2Header: { id: "course01.chapter02.lesson01.page04.col2Header" },
  C1_CH2_L1_P4_SoundLabel: { id: "course01.chapter02.lesson01.page03.soundlabel" },

  C1_CH2_L1_P5_Title: { id: "course01.chapter02.lesson01.page05.title" },
  C1_CH2_L1_P5_Description: { id: "course01.chapter02.lesson01.page05.description" },
  C1_CH2_L1_P5_Spatial: { id: "course01.chapter02.lesson01.page05.spatial" },
  C1_CH2_L1_P5_Nonspatial: { id: "course01.chapter02.lesson01.page05.nonspatial" },

  C1_CH1_L7_T1_Question: { id: "course01.chapter02.lesson01.task01.question" },
  C1_CH1_L7_T1_A1: { id: "course01.chapter02.lesson01.task01.answer01" },
  C1_CH1_L7_T1_A2: { id: "course01.chapter02.lesson01.task01.answer02" },
  C1_CH1_L7_T1_A3: { id: "course01.chapter02.lesson01.task01.answer03" },
  C1_CH1_L7_T1_A4: { id: "course01.chapter02.lesson01.task01.answer04" },
  C1_CH1_L7_T1_A5: { id: "course01.chapter02.lesson01.task01.answer05" },

  C1_CH1_L7_T2_Question: { id: "course01.chapter02.lesson01.task02.question" },
  C1_CH1_L7_T2_A1: { id: "course01.chapter02.lesson01.task02.answer01" }, //37
  C1_CH1_L7_T2_A2: { id: "course01.chapter02.lesson01.task02.answer02" }, //23
  C1_CH1_L7_T2_A3: { id: "course01.chapter02.lesson01.task02.answer03" }, //15
  C1_CH1_L7_T2_A4: { id: "course01.chapter02.lesson01.task02.answer04" }, //24
  C1_CH1_L7_T2_A5: { id: "course01.chapter02.lesson01.task02.answer05" }, //82
  C1_CH1_L7_T2_A6: { id: "course01.chapter02.lesson01.task02.answer06" }, //86

  C1_CH2_L2_Name: { id: "course01.chapter02.lesson02.name" },
  C1_CH2_L2_P1_Title: { id: "course01.chapter02.lesson02.page01.title" },
  C1_CH2_L2_P1_Description: { id: "course01.chapter02.lesson02.page01.description" },
  C1_CH2_L2_P1_Col1: { id: "course01.chapter02.lesson02.page01.col1" },
  C1_CH2_L2_P1_Col2: { id: "course01.chapter02.lesson02.page01.col2" },
  C1_CH2_L2_P1_SoundLabel: { id: "course01.chapter02.lesson02.page01.soundlabel" },

  C1_CH2_L2_T1_Question: { id: "course01.chapter02.lesson02.task01.question" },
  C1_CH2_L2_T1_A1: { id: "course01.chapter02.lesson02.task01.answer01" }, //37
  C1_CH2_L2_T1_A2: { id: "course01.chapter02.lesson02.task01.answer02" }, //23
  C1_CH2_L2_T1_A3: { id: "course01.chapter02.lesson02.task01.answer03" }, //15
  C1_CH2_L2_T1_A4: { id: "course01.chapter02.lesson02.task01.answer04" }, //24
  C1_CH2_L2_T1_A5: { id: "course01.chapter02.lesson02.task01.answer05" }, //82
  C1_CH2_L2_T1_A6: { id: "course01.chapter02.lesson02.task01.answer06" }, //86

  C1_CH2_L3_Name: { id: "course01.chapter02.lesson03.name" },
  C1_CH2_L3_P1_Title: { id: "course01.chapter02.lesson03.page01.title" },
  C1_CH2_L3_P1_Description: { id: "course01.chapter02.lesson03.page01.description" },
  C1_CH2_L3_P1_Soundsource: { id: "course01.chapter02.lesson03.page01.soundsource" },
  C1_CH2_L3_P1_H1: { id: "course01.chapter02.lesson03.page01.h1" },
  C1_CH2_L3_P1_Play1: { id: "course01.chapter02.lesson03.page01.play1" },
  C1_CH2_L3_P1_Play2: { id: "course01.chapter02.lesson03.page01.play2" },
  C1_CH2_L3_P1_Play3: { id: "course01.chapter02.lesson03.page01.play3" },
  C1_CH2_L3_P1_H2: { id: "course01.chapter02.lesson03.page01.h2" },
  C1_CH2_L3_P1_Play4: { id: "course01.chapter02.lesson03.page01.play4" },
  C1_CH2_L3_P1_Play5: { id: "course01.chapter02.lesson03.page01.play5" },
  C1_CH2_L3_P1_Play6: { id: "course01.chapter02.lesson03.page01.play6" },

  C1_CH2_L3_P2_Title: { id: "course01.chapter02.lesson03.page02.title" },
  C1_CH2_L3_P2_Description: { id: "course01.chapter02.lesson03.page02.description" },
  C1_CH2_L3_P2_Play1: { id: "course01.chapter02.lesson03.page02.play1" },
  C1_CH2_L3_P2_Play2: { id: "course01.chapter02.lesson03.page02.play2" },
  C1_CH2_L3_P3_Title: { id: "course01.chapter02.lesson03.page03.title" },
  C1_CH2_L3_P3_Description: { id: "course01.chapter02.lesson03.page03.description" },
  C1_CH2_L3_P3_Infobox: { id: "course01.chapter02.lesson03.page03.infobox" },

  C1_CH2_L3_T1_Question: { id: "course01.chapter02.lesson03.task01.question" },
  C1_CH2_L3_T1_A1: { id: "course01.chapter02.lesson03.task01.answer01" },
  C1_CH2_L3_T1_A2: { id: "course01.chapter02.lesson03.task01.answer02" },
  C1_CH2_L3_T1_A3: { id: "course01.chapter02.lesson03.task01.answer03" },
  C1_CH2_L3_T1_A4: { id: "course01.chapter02.lesson03.task01.answer04" },

  C1_CH2_L3_T1_G1: { id: "course01.chapter02.lesson03.task01.group01" },
  C1_CH2_L3_T1_G2: { id: "course01.chapter02.lesson03.task01.group02" },
  C1_CH2_L3_T1_G3: { id: "course01.chapter02.lesson03.task01.group03" },
  C1_CH2_L3_T1_G4: { id: "course01.chapter02.lesson03.task01.group04" },

  C1_CH2_L3_T2_Question: { id: "course01.chapter02.lesson03.task02.question" },
  C1_CH2_L3_T2_A1: { id: "course01.chapter02.lesson03.task02.answer01" },
  C1_CH2_L3_T2_A2: { id: "course01.chapter02.lesson03.task02.answer02" },
  C1_CH2_L3_T2_A3: { id: "course01.chapter02.lesson03.task02.answer03" },

  C1_CH2_L4_Name: { id: "course01.chapter02.lesson04.name" },
  C1_CH2_L4_P1_Title: { id: "course01.chapter02.lesson04.page01.title" },
  C1_CH2_L4_P1_Description: { id: "course01.chapter02.lesson04.page01.description" },

  C1_CH2_L4_T1_Question: { id: "course01.chapter02.lesson04.task01.question" },
  C1_CH2_L4_T1_A1: { id: "course01.chapter02.lesson04.task01.answer01" },
  C1_CH2_L4_T1_A2: { id: "course01.chapter02.lesson04.task01.answer02" },
  C1_CH2_L4_T1_A3: { id: "course01.chapter02.lesson04.task01.answer03" },
  C1_CH2_L4_T1_A4: { id: "course01.chapter02.lesson04.task01.answer04" },
  C1_CH2_L4_T1_A5: { id: "course01.chapter02.lesson04.task01.answer05" },
  C1_CH2_L4_T1_A6: { id: "course01.chapter02.lesson04.task01.answer06" },

  C1_CH2_L5_Name: { id: "course01.chapter02.lesson05.name" },
  C1_CH2_L5_P1_Title: { id: "course01.chapter02.lesson05.page01.title" },
  C1_CH2_L5_P1_Description: { id: "course01.chapter02.lesson05.page01.description" },
  C1_CH2_L5_P2_Title: { id: "course01.chapter02.lesson05.page02.title" },
  C1_CH2_L5_P2_Description: { id: "course01.chapter02.lesson05.page02.description" },
  C1_CH2_L5_P2_Soundlabel: { id: "course01.chapter02.lesson05.page02.soundlabel" },
  C1_CH2_L5_P2_Loudspeaker: { id: "course01.chapter02.lesson05.page02.loudspeaker" },
  C1_CH2_L5_P3_Title: { id: "course01.chapter02.lesson05.page03.title" },
  C1_CH2_L5_P3_Description: { id: "course01.chapter02.lesson05.page03.description" },
  C1_CH2_L5_T1_Question: { id: "course01.chapter02.lesson05.task01.question" },

  C1_CH3_L1_Name: { id: "course01.chapter03.lesson01.name" },
  C1_CH3_L1_P1_Title: { id: "course01.chapter03.lesson01.page01.title" },
  C1_CH3_L1_P1_Description: { id: "course01.chapter03.lesson01.page01.description" },
  C1_CH3_L1_P1_DataBoxIntro: { id: "course01.chapter03.lesson01.page01.databoxintro" },
  C1_CH3_L1_P1_Saxophone: { id: "course01.chapter03.lesson01.page01.saxophone" },
  C1_CH3_L1_P1_Guitar: { id: "course01.chapter03.lesson01.page01.guitar" },
  C1_CH3_L1_P1_Bass: { id: "course01.chapter03.lesson01.page01.bass" },
  C1_CH3_L1_P1_Soundlabel: { id: "course01.chapter03.lesson01.page02.soundlabel" },
  C1_CH3_L1_P2_Title: { id: "course01.chapter03.lesson01.page02.title" },
  C1_CH3_L1_P2_Description: { id: "course01.chapter03.lesson01.page02.description" },
  C1_CH3_L1_P2_Tab_Title1: { id: "course01.chapter03.lesson01.page02.tabtitle1" },
  C1_CH3_L1_P2_Tab_Title2: { id: "course01.chapter03.lesson01.page02.tabtitle2" },
  C1_CH3_L1_T1_Question: { id: "course01.chapter03.lesson01.task01.question" },
  C1_CH3_L1_T1_G1: { id: "course01.chapter03.lesson01.task01.group1" },
  C1_CH3_L1_T1_G2: { id: "course01.chapter03.lesson01.task01.group2" },
  C1_CH3_L1_T1_G3: { id: "course01.chapter03.lesson01.task01.group3" },
  C1_CH3_L1_T1_G4: { id: "course01.chapter03.lesson01.task01.group4" },
  C1_CH3_L1_T1_A1: { id: "course01.chapter03.lesson01.task01.answer01" },
  C1_CH3_L1_T1_A2: { id: "course01.chapter03.lesson01.task01.answer02" },
  C1_CH3_L1_T1_A3: { id: "course01.chapter03.lesson01.task01.answer03" },
  C1_CH3_L1_T1_A4: { id: "course01.chapter03.lesson01.task01.answer04" },
  C1_CH3_L2_Name: { id: "course01.chapter03.lesson02.name" },
  C1_CH3_L2_P1_Title: { id: "course01.chapter03.lesson02.page01.title" },
  C1_CH3_L2_P1_Description: { id: "course01.chapter03.lesson02.page01.description" },
  C1_CH3_L2_P1_Headphoneswarning: { id: "course01.chapter03.lesson02.page01.headphoneswarning" },
  C1_CH3_L2_P1_Soundsource: { id: "course01.chapter03.lesson02.page01.soundsource" },
  C1_CH3_L2_P1_H1: { id: "course01.chapter03.lesson02.page01.h1" },
  C1_CH3_L2_P1_H2: { id: "course01.chapter03.lesson02.page01.h2" },
  C1_CH3_L2_P1_Play1: { id: "course01.chapter03.lesson02.page01.play1" },
  C1_CH3_L2_P1_Play2: { id: "course01.chapter03.lesson02.page01.play2" },
  C1_CH3_L2_P1_Play3: { id: "course01.chapter03.lesson02.page01.play3" },
  C1_CH3_L2_P1_Play4: { id: "course01.chapter03.lesson02.page01.play4" },

  C1_CH3_L2_P2_Title: { id: "course01.chapter03.lesson02.page02.title" },
  C1_CH3_L2_P2_Description: { id: "course01.chapter03.lesson02.page02.description" },
  C1_CH3_L2_P2_Headphoneswarning: { id: "course01.chapter03.lesson02.page02.headphoneswarning" },

  C1_CH3_L2_T1_Question: { id: "course01.chapter03.lesson02.task01.question" },
  C1_CH3_L2_T1_A1: { id: "course01.chapter03.lesson02.task01.answer01" },
  C1_CH3_L2_T1_A2: { id: "course01.chapter03.lesson02.task01.answer02" },
  C1_CH3_L2_T1_A3: { id: "course01.chapter03.lesson02.task01.answer03" },
  C1_CH3_L2_T1_A4: { id: "course01.chapter03.lesson02.task01.answer04" },
  C1_CH3_L2_T1_A5: { id: "course01.chapter03.lesson02.task01.answer05" },

  C1_CH4_L1_Name: { id: "course01.chapter04.lesson01.name" },
  C1_CH4_L1_P1_Title: { id: "course01.chapter04.lesson01.page01.title" },
  C1_CH4_L1_P1_Description: { id: "course01.chapter04.lesson01.page01.description" },
  C1_CH4_L1_P1_SliderLabel: { id: "course01.chapter04.lesson01.page01.sliderlabel" },
  C1_CH4_L1_P1_SoundLabel: { id: "course01.chapter04.lesson01.page01.soundlabel" },
  C1_CH4_L1_T1_Question: { id: "course01.chapter04.lesson01.task01.question" },
  C1_CH4_L1_T1_L1: { id: "course01.chapter04.lesson01.task01.left01" },
  C1_CH4_L1_T1_L2: { id: "course01.chapter04.lesson01.task01.left02" },
  C1_CH4_L1_T1_L3: { id: "course01.chapter04.lesson01.task01.left03" },
  C1_CH4_L1_T1_L4: { id: "course01.chapter04.lesson01.task01.left04" },
  C1_CH4_L1_T1_L5: { id: "course01.chapter04.lesson01.task01.left05" },
  C1_CH4_L1_T1_L6: { id: "course01.chapter04.lesson01.task01.left06" },
  C1_CH4_L1_T1_R1: { id: "course01.chapter04.lesson01.task01.right01" },
  C1_CH4_L1_T1_R2: { id: "course01.chapter04.lesson01.task01.right02" },
  C1_CH4_L1_T1_R3: { id: "course01.chapter04.lesson01.task01.right03" },
  C1_CH4_L1_T1_R4: { id: "course01.chapter04.lesson01.task01.right04" },
  C1_CH4_L1_T1_R5: { id: "course01.chapter04.lesson01.task01.right05" },
  C1_CH4_L1_T1_R6: { id: "course01.chapter04.lesson01.task01.right06" },

  C1_CH4_L2_Name: { id: "course01.chapter04.lesson02.name" },
  C1_CH4_L2_P1_Title: { id: "course01.chapter04.lesson02.page01.title" },
  C1_CH4_L2_P2_Title: { id: "course01.chapter04.lesson02.page02.title" },
  C1_CH4_L2_P3_Title: { id: "course01.chapter04.lesson02.page03.title" },
  C1_CH4_L2_P4_Title: { id: "course01.chapter04.lesson02.page04.title" },
  C1_CH4_L2_T1_Question: { id: "course01.chapter04.lesson02.task01.question" },
  C1_CH4_L2_T1_G1: { id: "course01.chapter04.lesson02.task01.group01" },
  C1_CH4_L2_T1_G2: { id: "course01.chapter04.lesson02.task01.group02" },
  C1_CH4_L2_T1_A1: { id: "course01.chapter04.lesson02.task01.answer01" },
  C1_CH4_L2_T1_A2: { id: "course01.chapter04.lesson02.task01.answer02" },
  C1_CH4_L2_T1_A3: { id: "course01.chapter04.lesson02.task01.answer03" },
  C1_CH4_L2_T1_A4: { id: "course01.chapter04.lesson02.task01.answer04" },
  C1_CH4_L2_T1_A5: { id: "course01.chapter04.lesson02.task01.answer05" },

  C1_CH4_L3_Name: { id: "course01.chapter04.lesson03.name" },
  C1_CH4_L3_P1_Title: { id: "course01.chapter04.lesson03.page01.title" },
  C1_CH4_L3_P1_Description: { id: "course01.chapter04.lesson03.page01.description" },
  C1_CH4_L3_P1_Headphoneswarning: { id: "course01.chapter04.lesson03.page01.headphoneswarning" },
  C1_CH4_L3_T1_Question: { id: "course01.chapter04.lesson03.task01.question" },

  C1_CH4_L3_T1_L1: { id: "course01.chapter04.lesson03.task01.left01" },
  C1_CH4_L3_T1_L2: { id: "course01.chapter04.lesson03.task01.left02" },
  C1_CH4_L3_T1_L3: { id: "course01.chapter04.lesson03.task01.left03" },
  C1_CH4_L3_T1_R1: { id: "course01.chapter04.lesson03.task01.right01" },
  C1_CH4_L3_T1_R2: { id: "course01.chapter04.lesson03.task01.right02" },
  C1_CH4_L3_T1_R3: { id: "course01.chapter04.lesson03.task01.right03" },

  C1_CH4_L3_T2_Question: { id: "course01.chapter04.lesson03.task02.question" },
  C1_CH4_L3_T2_A1: { id: "course01.chapter04.lesson03.task02.answer01" },
  C1_CH4_L3_T2_A2: { id: "course01.chapter04.lesson03.task02.answer02" },
  C1_CH4_L3_T2_A3: { id: "course01.chapter04.lesson03.task02.answer03" },
  C1_CH4_L3_T2_A4: { id: "course01.chapter04.lesson03.task02.answer04" },
  C1_CH4_L3_T2_A5: { id: "course01.chapter04.lesson03.task02.answer05" },

  C1_CH5_L1_Name: { id: "course01.chapter05.lesson01.name" },
  C1_CH5_L1_P1_Title: { id: "course01.chapter05.lesson01.page01.title" },
  C1_CH5_L1_P1_Description: { id: "course01.chapter05.lesson01.page01.description" },
  C1_CH5_L1_P1_SoundLabel: { id: "course01.chapter05.lesson01.page01.soundlabel" },
  C1_CH5_L1_P1_Col1Name: { id: "course01.chapter05.lesson01.page01.col1" },
  C1_CH5_L1_P1_Col2Name: { id: "course01.chapter05.lesson01.page01.col2" },
  C1_CH5_L1_P1_Col3Name: { id: "course01.chapter05.lesson01.page01.col3" },

  C1_CH5_L1_T1_Question: { id: "course01.chapter05.lesson01.task01.question" },
  C1_CH5_L1_T1_A1: { id: "course01.chapter05.lesson01.task01.answer01" },
  C1_CH5_L1_T1_A2: { id: "course01.chapter05.lesson01.task01.answer02" },
  C1_CH5_L1_T1_A3: { id: "course01.chapter05.lesson01.task01.answer03" },
  C1_CH5_L1_T1_A4: { id: "course01.chapter05.lesson01.task01.answer04" },
  C1_CH5_L1_T1_A5: { id: "course01.chapter05.lesson01.task01.answer05" },

  C1_CH5_L2_Name: { id: "course01.chapter05.lesson02.name" },
  C1_CH5_L2_P1_Title: { id: "course01.chapter05.lesson02.page01.title" },
  C1_CH5_L2_P1_Description: { id: "course01.chapter05.lesson02.page01.description" },

  C1_CH5_L2_P1_StepText: { id: "course01.chapter05.lesson02.page01.steptext" },
  C1_CH5_L2_P1_Col1Description: { id: "course01.chapter05.lesson02.page01.col1Description" },
  C1_CH5_L2_P1_Col2Description: { id: "course01.chapter05.lesson02.page01.col2Description" },
  C1_CH5_L2_P1_Col3Description: { id: "course01.chapter05.lesson02.page01.col3Description" },

  C1_CH5_L2_T1_Question: { id: "course01.chapter05.lesson02.task01.question" },
  C1_CH5_L2_T1_A1: { id: "course01.chapter05.lesson02.task01.answer01" },
  C1_CH5_L2_T1_A2: { id: "course01.chapter05.lesson02.task01.answer02" },
  C1_CH5_L2_T1_A3: { id: "course01.chapter05.lesson02.task01.answer03" },
  C1_CH5_L2_T1_A4: { id: "course01.chapter05.lesson02.task01.answer04" },
  C1_CH5_L2_T1_A5: { id: "course01.chapter05.lesson02.task01.answer05" },

  C1_CH5_L3_Name: { id: "course01.chapter05.lesson03.name" },
  C1_CH5_L3_P1_Title: { id: "course01.chapter05.lesson03.page01.title" },
  C1_CH5_L3_P1_Description: { id: "course01.chapter05.lesson03.page01.description" },
  C1_CH5_L3_P1_Headphoneswarning: { id: "course01.chapter05.lesson03.page01.headphoneswarning" },
  C1_CH5_L3_T1_Question: { id: "course01.chapter05.lesson03.task01.question" },
  C1_CH5_L3_T1_A1: { id: "course01.chapter05.lesson03.task01.answer01" },
  C1_CH5_L3_T1_A2: { id: "course01.chapter05.lesson03.task01.answer02" },
  C1_CH5_L3_T1_A3: { id: "course01.chapter05.lesson03.task01.answer03" },
  C1_CH5_L3_T1_A4: { id: "course01.chapter05.lesson03.task01.answer04" },
  C1_CH5_L3_T1_A5: { id: "course01.chapter05.lesson03.task01.answer05" },

  C1_CH5_L4_Name: { id: "course01.chapter05.lesson04.name" },
  C1_CH5_L4_P1_Title: { id: "course01.chapter05.lesson04.page01.title" },
  C1_CH5_L4_P1_Description: { id: "course01.chapter05.lesson04.page01.description" },
  C1_CH5_L4_P1_Equalized: { id: "course01.chapter05.lesson04.page01.equalized" },
  C1_CH5_L4_P1_Unequalized: { id: "course01.chapter05.lesson04.page01.unequalized" },
  C1_CH5_L4_P1_Headphoneswarning: { id: "course01.chapter05.lesson04.page01.headphoneswarning" },
  C1_CH5_L4_T1_Soundlabel: { id: "course01.chapter05.lesson04.task01.soundlabel" },
  C1_CH5_L4_T1_Question: { id: "course01.chapter05.lesson04.task01.question" },
  C1_CH5_L4_T1_A1: { id: "course01.chapter05.lesson04.task01.answer01" },
  C1_CH5_L4_T1_A2: { id: "course01.chapter05.lesson04.task01.answer02" },
  C1_CH5_L4_T1_A3: { id: "course01.chapter05.lesson04.task01.answer03" },
  C1_CH5_L4_T1_A4: { id: "course01.chapter05.lesson04.task01.answer04" },

  C1_CH6_L1_Name: { id: "course01.chapter06.lesson01.name" },

  C1_CH6_L1_P0208_UpperLayerText: { id: "course01.chapter06.lesson01.page0108.upperlayertext" },
  C1_CH6_L1_P0208_MiddleLayerText: { id: "course01.chapter06.lesson01.page0108.middlelayertext" },
  C1_CH6_L1_P0208_BottomLayerText: { id: "course01.chapter06.lesson01.page0108.bottomlayertext" },
  C1_CH6_L1_P0208_FooterText: { id: "course01.chapter06.lesson01.page0208.footertext" },

  C1_CH6_L1_P1_Title: { id: "course01.chapter06.lesson01.page01.title" },
  C1_CH6_L1_P1_Description: { id: "course01.chapter06.lesson01.page01.description" },
  C1_CH6_L1_P2_Title: { id: "course01.chapter06.lesson01.page02.title" },
  C1_CH6_L1_P2_Description: { id: "course01.chapter06.lesson01.page02.description" },
  C1_CH6_L1_P2_ImageHeader: { id: "course01.chapter06.lesson01.page02.imageheader" },
  C1_CH6_L1_P3_Title: { id: "course01.chapter06.lesson01.page03.title" },
  C1_CH6_L1_P3_Description: { id: "course01.chapter06.lesson01.page03.description" },
  C1_CH6_L1_P3_ImageHeader: { id: "course01.chapter06.lesson01.page03.imageheader" },
  C1_CH6_L1_P4_Title: { id: "course01.chapter06.lesson01.page04.title" },
  C1_CH6_L1_P4_Description: { id: "course01.chapter06.lesson01.page04.description" },
  C1_CH6_L1_P4_ImageHeader: { id: "course01.chapter06.lesson01.page04.imageheader" },
  C1_CH6_L1_P5_Title: { id: "course01.chapter06.lesson01.page05.title" },
  C1_CH6_L1_P5_Description: { id: "course01.chapter06.lesson01.page05.description" },
  C1_CH6_L1_P5_ImageHeader: { id: "course01.chapter06.lesson01.page05.imageheader" },
  C1_CH6_L1_P6_Title: { id: "course01.chapter06.lesson01.page06.title" },
  C1_CH6_L1_P6_Description: { id: "course01.chapter06.lesson01.page06.description" },
  C1_CH6_L1_P6_ImageHeader: { id: "course01.chapter06.lesson01.page06.imageheader" },
  C1_CH6_L1_P7_Title: { id: "course01.chapter06.lesson01.page07.title" },
  C1_CH6_L1_P7_Description: { id: "course01.chapter06.lesson01.page07.description" },
  C1_CH6_L1_P7_ImageHeader: { id: "course01.chapter06.lesson01.page07.imageheader" },
  C1_CH6_L1_P8_Title: { id: "course01.chapter06.lesson01.page08.title" },
  C1_CH6_L1_P8_Description: { id: "course01.chapter06.lesson01.page08.description" },
  C1_CH6_L1_P8_ImageHeader: { id: "course01.chapter06.lesson01.page08.imageheader" },

  C1_CH6_L1_T1_Question: { id: "course01.chapter06.lesson01.task01.question" },
  C1_CH6_L1_T1_A1: { id: "course01.chapter06.lesson01.task01.answer01" },
  C1_CH6_L1_T1_A2: { id: "course01.chapter06.lesson01.task01.answer02" },
  C1_CH6_L1_T1_A3: { id: "course01.chapter06.lesson01.task01.answer03" },
  C1_CH6_L1_T1_A4: { id: "course01.chapter06.lesson01.task01.answer04" },

  C1_CH6_L2_Name: { id: "course01.chapter06.lesson02.name" },
  C1_CH6_L2_P1_Title: { id: "course01.chapter06.lesson02.page01.title" },
  C1_CH6_L2_P1_Description: { id: "course01.chapter06.lesson02.page01.description" },
  C1_CH6_L2_T1_Question: { id: "course01.chapter06.lesson02.task01.question" },
  C1_CH6_L2_T1_A1: { id: "course01.chapter06.lesson02.task01.answer01" },
  C1_CH6_L2_T1_A2: { id: "course01.chapter06.lesson02.task01.answer02" },
  C1_CH6_L2_T1_A3: { id: "course01.chapter06.lesson02.task01.answer03" },
  C1_CH6_L2_T1_A4: { id: "course01.chapter06.lesson02.task01.answer04" },
  C1_CH6_L2_T1_A5: { id: "course01.chapter06.lesson02.task01.answer05" },
  C1_CH6_L2_T1_A6: { id: "course01.chapter06.lesson02.task01.answer06" },
  C1_CH6_L2_T1_A7: { id: "course01.chapter06.lesson02.task01.answer07" },

  C1_CH6_L3_Name: { id: "course01.chapter06.lesson03.name" },
  C1_CH6_L3_P1_Title: { id: "course01.chapter06.lesson03.page01.title" },
  C1_CH6_L3_P1_Description: { id: "course01.chapter06.lesson03.page01.description" },

  C1_CH6_L3_T1_Question: { id: "course01.chapter06.lesson03.task01.question" },
  C1_CH6_L3_T1_A1: { id: "course01.chapter06.lesson03.task01.answer01" },
  C1_CH6_L3_T1_A2: { id: "course01.chapter06.lesson03.task01.answer02" },
  C1_CH6_L3_T1_A3: { id: "course01.chapter06.lesson03.task01.answer03" },
  C1_CH6_L3_T1_A4: { id: "course01.chapter06.lesson03.task01.answer04" },
  C1_CH6_L3_T1_A5: { id: "course01.chapter06.lesson03.task01.answer05" },

  C1_CH6_L4_Name: { id: "course01.chapter06.lesson04.name" },
  C1_CH6_L4_P1_Title: { id: "course01.chapter06.lesson04.page01.title" },
  C1_CH6_L4_P1_Description: { id: "course01.chapter06.lesson04.page01.description" },
  C1_CH6_L4_T1_Question: { id: "course01.chapter06.lesson04.task01.question" },
  C1_CH6_L4_T1_A1: { id: "course01.chapter06.lesson04.task01.answer01" },
  C1_CH6_L4_T1_A2: { id: "course01.chapter06.lesson04.task01.answer02" },
  C1_CH6_L4_T1_A3: { id: "course01.chapter06.lesson04.task01.answer03" },
  C1_CH6_L4_T1_A4: { id: "course01.chapter06.lesson04.task01.answer04" },

  C1_CH7_L1_Name: { id: "course01.chapter07.lesson01.name" },
  C1_CH7_L1_P1_Title: { id: "course01.chapter07.lesson01.page01.title" },
  C1_CH7_L1_P1_Description: { id: "course01.chapter07.lesson01.page01.description" },
  C1_CH7_L1_P2_Title: { id: "course01.chapter07.lesson01.page02.title" },
  C1_CH7_L1_P2_Description: { id: "course01.chapter07.lesson01.page02.description" },
  C1_CH7_L1_P3_Title: { id: "course01.chapter07.lesson01.page03.title" },
  C1_CH7_L1_P3_Description: { id: "course01.chapter07.lesson01.page03.description" },
  C1_CH7_L1_P4_Title: { id: "course01.chapter07.lesson01.page04.title" },
  C1_CH7_L1_P4_Description: { id: "course01.chapter07.lesson01.page04.description" },

  C1_CH7_L1_T1_Question: { id: "course01.chapter07.lesson01.task01.question" },
  C1_CH7_L1_T1_A1: { id: "course01.chapter07.lesson01.task01.answer01" },
  C1_CH7_L1_T1_A2: { id: "course01.chapter07.lesson01.task01.answer02" },
  C1_CH7_L1_T2_Question: { id: "course01.chapter07.lesson01.task02.question" },
  C1_CH7_L1_T2_A1: { id: "course01.chapter07.lesson01.task02.answer01" },
  C1_CH7_L1_T2_A2: { id: "course01.chapter07.lesson01.task02.answer02" },
  C1_CH7_L1_T3_Question: { id: "course01.chapter07.lesson01.task03.question" },
  C1_CH7_L1_T3_A1: { id: "course01.chapter07.lesson01.task03.answer01" },
  C1_CH7_L1_T3_A2: { id: "course01.chapter07.lesson01.task03.answer02" },
  C1_CH7_L1_T4_Question: { id: "course01.chapter07.lesson01.task04.question" },
  C1_CH7_L1_T4_A1: { id: "course01.chapter07.lesson01.task04.answer01" },
  C1_CH7_L1_T4_A2: { id: "course01.chapter07.lesson01.task04.answer02" },

  C1_CH7_L2_Name: { id: "course01.chapter07.lesson02.name" },
  C1_CH7_L2_P1_Title: { id: "course01.chapter07.lesson02.page01.title" },
  C1_CH7_L2_P1_Tab_Title1: { id: "course01.chapter07.lesson02.page01.tabtitle1" },
  C1_CH7_L2_P1_Tab_Title2: { id: "course01.chapter07.lesson02.page01.tabtitle2" },
  C1_CH7_L2_P1_Tab_Title3: { id: "course01.chapter07.lesson02.page01.tabtitle3" },
  C1_CH7_L2_P1_Tab_Title4: { id: "course01.chapter07.lesson02.page01.tabtitle4" },
  C1_CH7_L2_P1_Tab_Title5: { id: "course01.chapter07.lesson02.page01.tabtitle5" },
  C1_CH7_L2_P1_Tab_Title6: { id: "course01.chapter07.lesson02.page01.tabtitle6" },
  C1_CH7_L2_P1_Tab_Title7: { id: "course01.chapter07.lesson02.page01.tabtitle7" },
  C1_CH7_L2_P1_Tab_Title8: { id: "course01.chapter07.lesson02.page01.tabtitle8" },

  C1_CH7_L2_P2_Title: { id: "course01.chapter07.lesson02.page02.title" },
  C1_CH7_L2_T1_Question: { id: "course01.chapter07.lesson02.task01.question" },
  C1_CH7_L2_T1_A1: { id: "course01.chapter07.lesson02.task01.answer01" },
  C1_CH7_L2_T1_A2: { id: "course01.chapter07.lesson02.task01.answer02" },
  C1_CH7_L2_T2_Question: { id: "course01.chapter07.lesson02.task02.question" },
  C1_CH7_L2_T2_A1: { id: "course01.chapter07.lesson02.task02.answer01" },
  C1_CH7_L2_T2_A2: { id: "course01.chapter07.lesson02.task02.answer02" },
  C1_CH7_L2_T3_Question: { id: "course01.chapter07.lesson02.task03.question" },
  C1_CH7_L2_T3_A1: { id: "course01.chapter07.lesson02.task03.answer01" },
  C1_CH7_L2_T3_A2: { id: "course01.chapter07.lesson02.task03.answer02" },
  C1_CH7_L2_T4_Question: { id: "course01.chapter07.lesson02.task04.question" },
  C1_CH7_L2_T4_A1: { id: "course01.chapter07.lesson02.task04.answer01" },
  C1_CH7_L2_T4_A2: { id: "course01.chapter07.lesson02.task04.answer02" },

  C1_CH7_L3_Name: { id: "course01.chapter07.lesson03.name" },
  C1_CH7_L3_P1_Title: { id: "course01.chapter07.lesson03.page01.title" },
  C1_CH7_L3_P1_Description: { id: "course01.chapter07.lesson03.page01.description" },
  C1_CH7_L3_P2_Title: { id: "course01.chapter07.lesson03.page02.title" },
  C1_CH7_L3_P2_Description: { id: "course01.chapter07.lesson03.page02.description" },
  C1_CH7_L3_P3_Title: { id: "course01.chapter07.lesson03.page03.title" },
  C1_CH7_L3_P3_Description: { id: "course01.chapter07.lesson03.page03.description" },
  C1_CH7_L3_T1_Question: { id: "course01.chapter07.lesson03.task01.question" },
  C1_CH7_L3_T1_A1: { id: "course01.chapter07.lesson03.task01.answer01" },
  C1_CH7_L3_T1_A2: { id: "course01.chapter07.lesson03.task01.answer02" },
  C1_CH7_L3_T2_Question: { id: "course01.chapter07.lesson03.task02.question" },
  C1_CH7_L3_T2_A1: { id: "course01.chapter07.lesson03.task02.answer01" },
  C1_CH7_L3_T2_A2: { id: "course01.chapter07.lesson03.task02.answer02" },
  C1_CH7_L3_T3_Question: { id: "course01.chapter07.lesson03.task03.question" },
  C1_CH7_L3_T3_A1: { id: "course01.chapter07.lesson03.task03.answer01" },
  C1_CH7_L3_T3_A2: { id: "course01.chapter07.lesson03.task03.answer02" },
  C1_CH7_L3_T4_Question: { id: "course01.chapter07.lesson03.task04.question" },
  C1_CH7_L3_T4_A1: { id: "course01.chapter07.lesson03.task04.answer01" },
  C1_CH7_L3_T4_A2: { id: "course01.chapter07.lesson03.task04.answer02" },

  C1_CH7_L4_Name: { id: "course01.chapter07.lesson04.name" },
  C1_CH7_L4_P1_Title: { id: "course01.chapter07.lesson04.page01.title" },
  C1_CH7_L4_P1_Description: { id: "course01.chapter07.lesson04.page01.description" },
  C1_CH7_L4_P1_UpperLayerText: { id: "course01.chapter07.lesson04.page01.upperlayertext" },
  C1_CH7_L4_P1_MiddleLayerText: { id: "course01.chapter07.lesson04.page01.middlelayertext" },
  C1_CH7_L4_P1_BottomLayerText: { id: "course01.chapter07.lesson04.page01.bottomlayertext" },

  C1_CH7_L4_P2_Title: { id: "course01.chapter07.lesson04.page02.title" },
  C1_CH7_L4_P2_Description: { id: "course01.chapter07.lesson04.page02.description" },
  C1_CH7_L4_P2_UpperLayerText: { id: "course01.chapter07.lesson04.page02.upperlayertext" },
  C1_CH7_L4_P2_HighLayerText: { id: "course01.chapter07.lesson04.page02.highlayertext" },
  C1_CH7_L4_P2_MiddleLayerText: { id: "course01.chapter07.lesson04.page02.middlelayertext" },
  C1_CH7_L4_P2_BottomLayerText: { id: "course01.chapter07.lesson04.page02.bottomlayertext" },

  C1_CH7_L4_T1_Question: { id: "course01.chapter07.lesson04.task01.question" },
  C1_CH7_L4_T1_A1: { id: "course01.chapter07.lesson04.task01.answer01" },
  C1_CH7_L4_T1_A2: { id: "course01.chapter07.lesson04.task01.answer02" },
  C1_CH7_L4_T2_Question: { id: "course01.chapter07.lesson04.task02.question" },
  C1_CH7_L4_T2_A1: { id: "course01.chapter07.lesson04.task02.answer01" },
  C1_CH7_L4_T2_A2: { id: "course01.chapter07.lesson04.task02.answer02" },
  C1_CH7_L4_T3_Question: { id: "course01.chapter07.lesson04.task03.question" },
  C1_CH7_L4_T3_A1: { id: "course01.chapter07.lesson04.task03.answer01" },
  C1_CH7_L4_T3_A2: { id: "course01.chapter07.lesson04.task03.answer02" },
  C1_CH7_L4_T4_Question: { id: "course01.chapter07.lesson04.task04.question" },
  C1_CH7_L4_T4_A1: { id: "course01.chapter07.lesson04.task04.answer01" },
  C1_CH7_L4_T4_A2: { id: "course01.chapter07.lesson04.task04.answer02" },

  C1_CH7_L5_Name: { id: "course01.chapter07.lesson05.name" },
  C1_CH7_L5_P1_Title: { id: "course01.chapter07.lesson05.page01.title" },
  C1_CH7_L5_P1_Description: { id: "course01.chapter07.lesson05.page01.description" },
  C1_CH7_L5_T1_Question: { id: "course01.chapter07.lesson05.task01.question" },
  C1_CH7_L5_T1_A1: { id: "course01.chapter07.lesson05.task01.answer01" },
  C1_CH7_L5_T1_A2: { id: "course01.chapter07.lesson05.task01.answer02" },
  C1_CH7_L5_T2_Question: { id: "course01.chapter07.lesson05.task02.question" },
  C1_CH7_L5_T2_A1: { id: "course01.chapter07.lesson05.task02.answer01" },
  C1_CH7_L5_T2_A2: { id: "course01.chapter07.lesson05.task02.answer02" },
  C1_CH7_L5_T3_Question: { id: "course01.chapter07.lesson05.task03.question" },
  C1_CH7_L5_T3_A1: { id: "course01.chapter07.lesson05.task03.answer01" },
  C1_CH7_L5_T3_A2: { id: "course01.chapter07.lesson05.task03.answer02" },

  C1_CH7_L6_Name: { id: "course01.chapter07.lesson06.name" },
  C1_CH7_L6_P1_Title: { id: "course01.chapter07.lesson06.page01.title" },
  C1_CH7_L6_P1_Description: { id: "course01.chapter07.lesson06.page01.description" },
  C1_CH7_L6_T1_Question: { id: "course01.chapter07.lesson06.task01.question" },
  C1_CH7_L6_T1_A1: { id: "course01.chapter07.lesson06.task01.answer01" },
  C1_CH7_L6_T1_A2: { id: "course01.chapter07.lesson06.task01.answer02" },
  C1_CH7_L6_T2_Question: { id: "course01.chapter07.lesson06.task02.question" },
  C1_CH7_L6_T2_A1: { id: "course01.chapter07.lesson06.task02.answer01" },
  C1_CH7_L6_T2_A2: { id: "course01.chapter07.lesson06.task02.answer02" },
  C1_CH7_L6_T3_Question: { id: "course01.chapter07.lesson06.task03.question" },
  C1_CH7_L6_T3_A1: { id: "course01.chapter07.lesson06.task03.answer01" },
  C1_CH7_L6_T3_A2: { id: "course01.chapter07.lesson06.task03.answer02" },
  C1_CH7_L6_T4_Question: { id: "course01.chapter07.lesson06.task04.question" },
  C1_CH7_L6_T4_A1: { id: "course01.chapter07.lesson06.task04.answer01" },
  C1_CH7_L6_T4_A2: { id: "course01.chapter07.lesson06.task04.answer02" },

  C1_CH7_L7_Name: { id: "course01.chapter07.lesson07.name" },
  C1_CH7_L7_P1_Title: { id: "course01.chapter07.lesson07.page01.title" },
  C1_CH7_L7_P1_Description: { id: "course01.chapter07.lesson07.page01.description" },
  C1_CH7_L7_T1_Question: { id: "course01.chapter07.lesson07.task01.question" },
  C1_CH7_L7_T1_A1: { id: "course01.chapter07.lesson07.task01.answer01" },
  C1_CH7_L7_T1_A2: { id: "course01.chapter07.lesson07.task01.answer02" },
  C1_CH7_L7_T2_Question: { id: "course01.chapter07.lesson07.task02.question" },
  C1_CH7_L7_T2_A1: { id: "course01.chapter07.lesson07.task02.answer01" },
  C1_CH7_L7_T2_A2: { id: "course01.chapter07.lesson07.task02.answer02" },
  C1_CH7_L7_T3_Question: { id: "course01.chapter07.lesson07.task03.question" },
  C1_CH7_L7_T3_A1: { id: "course01.chapter07.lesson07.task03.answer01" },
  C1_CH7_L7_T3_A2: { id: "course01.chapter07.lesson07.task03.answer02" },
  C1_CH7_L7_T4_Question: { id: "course01.chapter07.lesson07.task04.question" },
  C1_CH7_L7_T4_A1: { id: "course01.chapter07.lesson07.task04.answer01" },
  C1_CH7_L7_T4_A2: { id: "course01.chapter07.lesson07.task04.answer02" },
});
